import Service from '@/helpers/service'

export default {
    get(page, params) {
        return Service().get('McrReportLeadTime?page=' + page, {params});
    }, 
}